import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/introBreakdownSagas";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";
import { useDateFormat } from "../../../../hooks/useDateFormat";

const DatePicker = () => {
  const dispatch = useDispatch();
  const dateFormat = useDateFormat();

  let {
    selectedRequestDates: { startDate, endDate },
    currentUser: { calendarEndDate, calendarStartDate }
  } = useSelector((state) => state.introBreakdown);

  let updateDates = (startDate, endDate) =>
    dispatch(actionCreators.updateDates({ startDate, endDate }));

  return (
    <ReactDatePicker
      displayFormat={dateFormat}
      showDefaultInputIcon={false}
      isRangePicker
      startDate={startDate}
      endDate={endDate}
      calendarEndDate={calendarEndDate}
      minDate={calendarStartDate}
      updateDates={updateDates}
    />
  );
};

export default DatePicker;
